import { SET_USER } from './const';

export const setUser = ({ data }: { data: UserInfo }) => ({
  type: SET_USER,
  payload: { data },
});
